export default "__VITE_ASSET__hRqMFhl9__"